import { FC, useEffect, useState } from 'react';
import { ReportPreviewStatus } from '../../../../../states/statusWorker/statusWorker.state';
import { useTranslation } from 'react-i18next';
import { IProductionListProps, SIconButton } from '../../productionList.component';
import { printJobsDetailsState } from '../../../../../states/printJobsDetails.state';
import { CircularProgress } from '@mui/material';
import { SPrintIcon } from './printButton.component';

export const PrintAllReportsButton: FC<IPrintAllReportsButtonProps> = (props) => {
  const { previewAllStatus, previewListStatus, datePeriod, actionAllHandle, isPrintingAvailable } =
    props;
  const { t } = useTranslation();

  const isAllReportsDownloaded =
    (previewAllStatus === 'readyForPrint' || previewAllStatus === ReportPreviewStatus.ready) &&
    isPrintingAvailable;
  const isDisabled = previewAllStatus === ReportPreviewStatus.disabled;
  const [shouldAutoPrintAll, setShouldAutoPrintAll] = useState<boolean>(false);

  // Auto-print all reports when they are downloaded and auto-print flag is set
  useEffect(() => {
    if (shouldAutoPrintAll && isAllReportsDownloaded) {
      setShouldAutoPrintAll(false);
      printJobsDetailsState.pub.printProductionReports(
        previewListStatus
          .filter(
            (item) =>
              (item.status === ReportPreviewStatus.ready ||
                item.status === ReportPreviewStatus.viewed) &&
              item.url,
          )
          .map((item) => ({
            productionPrintListId: item.uuid,
            onDate: datePeriod.fromDate,
            pdfUrl: item.url!,
          })),
      );
    }
  }, [shouldAutoPrintAll, isAllReportsDownloaded, previewListStatus, datePeriod.fromDate]);

  const handlePrint = () => {
    if (isDisabled) {
      return;
    }
    if (isAllReportsDownloaded) {
      // All PDF are downloaded - print immediately
      printJobsDetailsState.pub.printProductionReports(
        previewListStatus
          .filter(
            (item) =>
              (item.status === ReportPreviewStatus.ready ||
                item.status === ReportPreviewStatus.viewed) &&
              item.url,
          )
          .map((item) => ({
            productionPrintListId: item.uuid,
            onDate: datePeriod.fromDate,
            pdfUrl: item.url!,
          })),
      );
    } else {
      // PDF are not downloaded - first download, then auto-print
      setShouldAutoPrintAll(true);
      actionAllHandle();
    }
  };

  return (
    <>
      {isPrintingAvailable && (
        <SIconButton
          onClick={handlePrint}
          title={t('common.print_all')}
          disabled={previewAllStatus === ReportPreviewStatus.loading || isDisabled}
        >
          {previewAllStatus === ReportPreviewStatus.loading ? (
            <CircularProgress size={20} />
          ) : (
            <SPrintIcon state={isDisabled ? 'disabled' : undefined} />
          )}
        </SIconButton>
      )}
    </>
  );
};

interface IPrintAllReportsButtonProps
  extends Pick<IProductionListProps, 'previewAllStatus' | 'previewListStatus' | 'datePeriod'> {
  actionAllHandle: () => void;
  isPrintingAvailable?: boolean;
}
